import { getStatusFromStatusCode, OperationStatus } from '../workplace/OperationStatus';

export enum RequestDetailsOption {
  regularOperations = '01',
  restorationComplete = '22',
  noEntry = '23',
  rescueComplete = '26',
  underPowerOutage = '31',
  propertyDamageMainGovRope = '71',
  propertyDamageOffTrack = '72',
  propertyDamageLanding = '73',
  propertyDamageDoor = '74',
  propertyDamageOther = '75',
  updateOnlyComment = '99',
}

export interface RequestDetailsModel {
  initial: RequestDetailsOption;
  list: RequestDetailsOption[];
}
export class RequestDetailsOptionFactory {
  static generateSet(code: string): RequestDetailsModel {
    switch (getStatusFromStatusCode(code)) {
      case OperationStatus.Entrapment:
        return {
          initial: RequestDetailsOption.rescueComplete,
          list: [
            RequestDetailsOption.rescueComplete,
            RequestDetailsOption.regularOperations,
            RequestDetailsOption.updateOnlyComment,
          ],
        };
      case OperationStatus.Suspended:
      case OperationStatus.ConfirmationRequired:
      case OperationStatus.SiteInaccessible:
        return {
          initial: RequestDetailsOption.restorationComplete,
          list: [
            RequestDetailsOption.restorationComplete,
            RequestDetailsOption.regularOperations,
            RequestDetailsOption.propertyDamageMainGovRope,
            RequestDetailsOption.propertyDamageOffTrack,
            RequestDetailsOption.propertyDamageLanding,
            RequestDetailsOption.propertyDamageDoor,
            RequestDetailsOption.propertyDamageOther,
            RequestDetailsOption.noEntry,
            RequestDetailsOption.underPowerOutage,
            RequestDetailsOption.updateOnlyComment,
          ],
        };
      default:
        return {
          initial: RequestDetailsOption.regularOperations,
          list: [
            RequestDetailsOption.restorationComplete,
            RequestDetailsOption.regularOperations,
            RequestDetailsOption.propertyDamageMainGovRope,
            RequestDetailsOption.propertyDamageOffTrack,
            RequestDetailsOption.propertyDamageLanding,
            RequestDetailsOption.propertyDamageDoor,
            RequestDetailsOption.propertyDamageOther,
            RequestDetailsOption.noEntry,
            RequestDetailsOption.underPowerOutage,
            RequestDetailsOption.updateOnlyComment,
          ],
        };
    }
  }
  static getOptionTranslationKey(option: RequestDetailsOption) {
    switch (option) {
      case RequestDetailsOption.rescueComplete:
        return 'wards.common.radioOptionStatusChange.rescueComplete';
      case RequestDetailsOption.restorationComplete:
        return 'wards.common.radioOptionStatusChange.recoveryComplete';
      case RequestDetailsOption.regularOperations:
        return 'wards.common.radioOptionStatusChange.seismometerNotActive';
      case RequestDetailsOption.propertyDamageMainGovRope:
        return 'wards.common.radioOptionStatusChange.propertyDamageMainGov';
      case RequestDetailsOption.propertyDamageOffTrack:
        return 'wards.common.radioOptionStatusChange.propertyDamageCTWDerail';
      case RequestDetailsOption.propertyDamageDoor:
        return 'wards.common.radioOptionStatusChange.propertyDamageDoor';
      case RequestDetailsOption.propertyDamageOther:
        return 'wards.common.radioOptionStatusChange.propertyDamageOther';
      case RequestDetailsOption.underPowerOutage:
        return 'wards.common.radioOptionStatusChange.underPowerOutage';
      case RequestDetailsOption.noEntry:
        return 'wards.common.radioOptionStatusChange.noEntry';
      case RequestDetailsOption.propertyDamageLanding:
        return 'wards.common.radioOptionStatusChange.propertyDamageGear';
      case RequestDetailsOption.updateOnlyComment:
        return 'wards.common.radioOptionStatusChange.updateOnlyComment';
    }
  }
}
